var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{class:[
		'col-12 d-flex d-md-none nav-mobile',
		{ 'inactive': _vm.active },
	]},[_c('a',{staticClass:"btn bt-arrow bt-menu-steps",attrs:{"href":"javascript:"},on:{"click":_vm.onSelectMenu}},[_c('i',{staticClass:"fa fa-chevron-down"})]),_vm._v(" "),_c('ul',{staticClass:"progress-buttons horizontal nav",attrs:{"role":"tablist"}},_vm._l((_vm.STEPS),function(s){return _c('li',{staticClass:"step",attrs:{"role":"tab","data-id":s},on:{"click":_vm.onSelectStep}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }